module.exports = __webpack_public_path__ + "static/GW16-bb8d0dbe2f4cdc839b5e93b43481b070.jpg";